import Input from "../../Common/components/Inputs/Input/Input";
import mechanicsMiddle from "../Assets/Sizing/additional_transmission_shaft.png";
import mechanicsConveyorBelt from "../Assets/Sizing/mechanism_conveyor.png";
import mechanicsCrank from "../Assets/Sizing/mechanism_crank_linear_motion.png";
import mechanicsSpindleDrive from "../Assets/Sizing/mechanism_lead_screw.png";
import mechanicsTail from "../Assets/Sizing/mechanism_motor.png";
import mechanicsRackPinion from "../Assets/Sizing/mechanism_rack_pinion.png";
import mechanicsRollFeed from "../Assets/Sizing/mechanism_roll_feed.png";
import mechanicsRotaryTable from "../Assets/Sizing/mechanism_rotary_table.png";
import mechanicsHead from "../Assets/Sizing/mechanism_universal_833x542.png";

import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MsxIcons from "../../Common/components/Icons/MsxIcons/MsxIcons";
import ToggleInput from "../../Common/components/Inputs/ToggleInput/ToggleInput";
import { STEPS } from "../../Common/store/data/commonData";
import { updateConfiguration } from "../../Common/store/slices/common";
import { selectSizingMechanics, setCurrentSizingStep, setSizingMechanics } from "../store/slices/retrofit";
import CustomSelect from "./CustomSelect";
import GuidedTour from "./GuidedTour";
import "./Sizing.scss";
import TopSection from "./TopSection";

const FEED_CONSTANT = "feedConstant";

const mechanicsImages = {
  "General loading case": mechanicsHead,
  "Rotary table": mechanicsRotaryTable,
  "Roll feed": mechanicsRollFeed,
  "Conveyor belt": mechanicsConveyorBelt,
  "Spindle drive": mechanicsSpindleDrive,
  "Rack and pinion gear": mechanicsRackPinion,
  // eslint-disable-next-line prettier/prettier
  Crank: mechanicsCrank
};

const GUIDED_STEPS = [
  {
    selector: ".step-1",
    content: "This is the first step of the tour!",
    position: "bottom"
  },
  {
    selector: ".step-2",
    content: "This is the second step of the tour!",
    position: "right"
  },
  {
    selector: ".step-3",
    content: "This is the third step of the tour!",
    position: "left"
  },
  {
    selector: ".step-4",
    content: "This is the fourth step of the tour!",
    position: "left"
  }
];
const mandatoryFields = {
  "General loading case": ["feedConstant"],
  "Rotary table": ["feedConstant"],
  "Roll feed": ["diameterDriveRoll", "massLoad", "momentOfInertiaDriveRoll", "momentOfInertiaDrivenRoll"],
  "Conveyor belt": [
    "diameterDriveRoll",
    "massLoad",
    "massBelt",
    "momentOfInertiaDriveRoll",
    "momentOfInertiaDrivenRoll"
  ],
  "Spindle drive": ["threadPitch", "efficiency"],
  "Rack and pinion gear": ["pinion", "toothPitch", "numberOfTeeth", "massLoad", "massRack"],
  // eslint-disable-next-line prettier/prettier
  Crank: [
    "crankArmLength",
    "pushRodLength",
    "xStart",
    "offsetFromSlideLevelToCrankShaft",
    "minimalPositionOfTheSlide",
    "maximalPositionOfTheSlide",
    "massLoad"
  ]
};

const MechanicsOptionsLabels = [
  "General loading case",
  "Rotary table",
  "Roll feed",
  "Conveyor belt",
  "Spindle drive",
  "Rack and pinion gear",
  "Crank"
];
const MechanicsOptions = ({ handleInputChange, mechanics }) => {
  const mechanicsVal = mechanics.isMechanics;
  console.log("Updated mechanics:", mechanics);
  return (
    <div className="ml-2 mb-2 mt-2 flex flex-col items-start space-y-3 bg-[#FFFFFF]">
      {MechanicsOptionsLabels.map((option) => {
        return (
          <div className="flex space-x-2 items-center">
            <input
              onClick={handleInputChange}
              checked={mechanicsVal === option}
              type="checkbox"
              value=""
              name={option}
              className={`w-5 h-5 appearance-none border-1 group-hover:border-2 group-hover:border-primary rounded-full cursor-pointer transition-all duration-100 checked:bg-primary focus:ring-primary ${"bg-white"}`}
            />
            <label className="text-sm" htmlFor={option}>
              {option}
            </label>
          </div>
        );
      })}
    </div>
  );
};

const LeftSection = ({ isTourEnabled, setIsTourEnabled, handleInputChange, mechanics }) => {
  const selectedImage = mechanicsImages[mechanics.isMechanics] || mechanicsHead;
  return (
    <>
      <div className="w-[70%] flex- space-y-10">
        <div className="mb-4">Add description here to guide the user better throughout the process for each tab.</div>
        <div className="pl-3 flex flex-col space-y-3">
          <div className="flex mt-[10%]">
            <div className="step-1 flex-1 border-2 border-solid border-primary rounded-lg">
              <img src={selectedImage} alt="linearAxis" className="w-full bg-gray-100 rounded-t-lg" />
              <MechanicsOptions handleInputChange={handleInputChange} mechanics={mechanics} />
            </div>
            <div className="flex-1 border-y-2 border-transparent pointer-events-none opacity-50">
              <img src={mechanicsMiddle} alt="linearAxis" className="w-full" />
            </div>
            <div className="flex-1 border-y-2 border-transparent pointer-events-none opacity-50">
              <img src={mechanicsMiddle} alt="linearAxis" className="w-full" />
            </div>
            <div className="flex-1 border-y-2 border-transparent pointer-events-none opacity-50">
              <img src={mechanicsTail} alt="linearAxis" className="w-full" />
            </div>
          </div>
        </div>
        <HelpMeToUseSection isTourEnabled={isTourEnabled} setIsTourEnabled={setIsTourEnabled} />
      </div>
    </>
  );
};

const AddOption = ({
  name,
  label,
  subLabel,
  unitVal,
  value = "",
  handleInputChange,
  options,
  labelRequired = false,
  inputClasses = ""
}) => {
  return (
    <>
      <div className="flex flex-col ml-3">
        <div className="flex-row">
          <span className="flex-1 md:text-sm">{label}</span>
          {labelRequired && <span className="light-error-active">*</span>}
        </div>
        <span className="flex-1 md:text-xs mr-5">{subLabel}</span>
        <div className="flex flex-row">
          <Input
            type="number"
            pattern="^\d+(\.\d{1,2})?$"
            autoComplete="off"
            required
            name={name}
            value={value}
            label=""
            placeHolder="Enter value"
            labelRequired={labelRequired}
            onChange={handleInputChange}
            inputClasses={inputClasses}
            inputRounded={true}
          />
          <CustomSelect name={name} unitVal={unitVal} handleInputChange={handleInputChange} options={options} />
        </div>
      </div>
    </>
  );
};

const pinionsLabels = ["Tooth", "Diameter"];
const AddOptionRadio = ({ label, subLabel, handleInputChange, mechanics }) => {
  const pinionVal = mechanics.pinion;
  return (
    <div className="flex flex-col ml-3">
      <div className="flex-row">
        <span className="flex-1 md:text-sm">{label}</span>
      </div>
      <span className="flex-1 md:text-xs mr-5">{subLabel}</span>
      <div className="flex flex-row">
        <div className="flex flex-row space-x-4 bg-[#FFFFFF]">
          {pinionsLabels.map((option) => {
            return (
              <div className="flex items-center space-x-2" key={option}>
                <input
                  onClick={handleInputChange}
                  checked={pinionVal === option}
                  type="checkbox"
                  value={option}
                  name="pinion"
                  className="w-5 h-5 appearance-none border-1 group-hover:border-2 group-hover:border-primary rounded-full cursor-pointer transition-all duration-100 checked:bg-primary checked:border-primary focus:ring-primary"
                />
                <label className="text-sm" htmlFor={option}>
                  {option}
                </label>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

const ApplySection = ({ enable, handleContinue }) => {
  return (
    <div className="flex justify-center">
      <qds-button
        id="naviguator-button-continue"
        {...(!enable ? { disabled: "" } : {})}
        importance="emphasized"
        onClick={() => {
          handleContinue();
        }}
        text="Go to define dynamics"
      ></qds-button>
    </div>
  );
};

const RightSection = ({ handleInputChange, mechanics, handleContinue }) => {
  const [hideDetails, setHideDetails] = useState(false);
  const subLabeltext = "A ??? is any component, sensor/actuator, that is connected to the Control ";
  return (
    <div className="w-[30%] border-solid border-l-[1px] shadow-md">
      <div className=" flex flex-col h-full">
        <div className="mt-1 mb-1 h-[5%]">
          <TopSection
            hideDetails={hideDetails}
            setHideDetails={setHideDetails}
            mandatoryfieldsMissing={
              mandatoryFields[mechanics.isMechanics]?.filter(
                (field) => !mechanics[field] || mechanics[field].trim() === ""
              ).length || 0
            }
          />
        </div>
        <div className="flex border-solid border-t-[1px] mb-2" />
        {mechanics.isMechanics === "General loading case" && (
          <div className="ml-3 thin-scrollbar overflow-visible h-full">
            <AddOption
              name={FEED_CONSTANT}
              value={mechanics.feedConstant}
              unitVal={mechanics.feedConstantUnit}
              handleInputChange={handleInputChange}
              label="Feed constant"
              options={["°.1-1", "mm.1-1", "in.1-1", "Unit.1-1"]}
              labelRequired={true}
              inputClasses="step-4 rounded-md"
              subLabel={hideDetails ? subLabeltext : ""}
            />
            <AddOption
              name="momentOfInertiaLoad"
              value={mechanics.momentOfInertiaLoad}
              unitVal={mechanics.momentOfInertiaLoadUnit}
              handleInputChange={handleInputChange}
              label="Moment of Inertia of the load"
              options={["kg.cm²", "kg.m²", "oz.in²", "lb.in²", "lb.ft²"]}
              subLabel={hideDetails ? subLabeltext : ""}
              inputClasses="rounded-md"
            />
            {/* <CalculatorSection /> */}
            <AddOption
              name="kineticFrictionTorque"
              value={mechanics.kineticFrictionTorque}
              unitVal={mechanics.kineticFrictionTorqueUnit}
              handleInputChange={handleInputChange}
              label="Kinetic friction torque"
              options={["N.m", "lb.ft"]}
              subLabel={hideDetails ? subLabeltext : ""}
              inputClasses="rounded-md"
            />
            <AddOption
              name="additionalTorqueConstant"
              value={mechanics.additionalTorqueConstant}
              unitVal={mechanics.additionalTorqueConstantUnit}
              handleInputChange={handleInputChange}
              label="Additional constant torque"
              options={["N.m", "lb.ft"]}
              subLabel={hideDetails ? subLabeltext : ""}
              inputClasses="rounded-md"
            />
            <AddOption
              name="viscousFrictionTorque"
              value={mechanics.viscousFrictionTorque}
              unitVal={mechanics.viscousFrictionTorqueUnit}
              handleInputChange={handleInputChange}
              label="Viscous friction torque"
              options={["N.m/(1000 1.s-1)", "N.m/(1000 1.min-1)", "lb.ft/(1000 1.s-1)", "lb.ft/(1000 1.min-1)"]}
              subLabel={hideDetails ? subLabeltext : ""}
              inputClasses="rounded-md"
            />
            <div className="mb-3" />
          </div>
        )}
        {mechanics.isMechanics === "Rotary table" && (
          <div className="ml-3 thin-scrollbar overflow-visible h-full">
            <AddOption
              name={FEED_CONSTANT}
              value={mechanics.feedConstant}
              unitVal={mechanics.feedConstantUnit}
              handleInputChange={handleInputChange}
              label="Feed constant"
              options={["°.1-1", "mm.1-1", "in.1-1", "Unit.1-1"]}
              labelRequired={true}
              inputClasses="step-4 rounded-md"
              subLabel={hideDetails ? subLabeltext : ""}
            />
            <AddOption
              name="momentOfInertiaLoad"
              value={mechanics.momentOfInertiaLoad}
              unitVal={mechanics.momentOfInertiaLoadUnit}
              handleInputChange={handleInputChange}
              label="Moment of Inertia of the load"
              options={["kg.cm²", "kg.m²", "oz.in²", "lb.in²", "lb.ft²"]}
              subLabel={hideDetails ? subLabeltext : ""}
              inputClasses="rounded-md"
            />
            {/* <CalculatorSection /> */}
            <AddOption
              name="kineticFrictionTorque"
              value={mechanics.kineticFrictionTorque}
              unitVal={mechanics.kineticFrictionTorqueUnit}
              handleInputChange={handleInputChange}
              label="Kinetic friction torque"
              options={["N.m", "lb.ft"]}
              subLabel={hideDetails ? subLabeltext : ""}
              inputClasses="rounded-md"
            />
            <AddOption
              name="additionalTorqueConstant"
              value={mechanics.additionalTorqueConstant}
              unitVal={mechanics.additionalTorqueConstantUnit}
              handleInputChange={handleInputChange}
              label="Additional constant torque"
              options={["N.m", "lb.ft"]}
              subLabel={hideDetails ? subLabeltext : ""}
              inputClasses="rounded-md"
            />
            <AddOption
              name="viscousFrictionTorque"
              value={mechanics.viscousFrictionTorque}
              unitVal={mechanics.viscousFrictionTorqueUnit}
              handleInputChange={handleInputChange}
              label="Viscous friction torque"
              options={["N.m/(1000 1.s-1)", "N.m/(1000 1.min-1)", "lb.ft/(1000 1.s-1)", "lb.ft/(1000 1.min-1)"]}
              subLabel={hideDetails ? subLabeltext : ""}
              inputClasses="rounded-md"
            />
            <div className="mb-3" />
          </div>
        )}
        {mechanics.isMechanics === "Roll feed" && (
          <div className="ml-3 thin-scrollbar overflow-visible h-full">
            <AddOption
              name="diameterDriveRoll"
              value={mechanics.diameterDriveRoll}
              unitVal={mechanics.diameterDriveRollUnit}
              handleInputChange={handleInputChange}
              label="diameterof the drive roll"
              options={["m", "mm", "cm", "in", "ft"]}
              labelRequired={true}
              inputClasses="step-4 rounded-md"
              subLabel={hideDetails ? subLabeltext : ""}
            />
            <AddOption
              name="massLoad"
              value={mechanics.massLoad}
              unitVal={mechanics.massLoadUnit}
              handleInputChange={handleInputChange}
              label="Mass of the load"
              options={["kg", "g", "lb", "oz."]}
              labelRequired={true}
              subLabel={hideDetails ? subLabeltext : ""}
              inputClasses="rounded-md"
            />
            <AddOption
              name="momentOfInertiaDriveRoll"
              value={mechanics.momentOfInertiaDriveRoll}
              unitVal={mechanics.momentOfInertiaDriveRollUnit}
              handleInputChange={handleInputChange}
              label="Moment of inertia of the drive roll"
              labelRequired={true}
              options={["kg.cm²", "kg.m²", "oz.in²", "lb.in²", "lb.ft²"]}
              subLabel={hideDetails ? subLabeltext : ""}
              inputClasses="rounded-md"
            />
            <AddOption
              name="momentOfInertiaDrivenRoll"
              value={mechanics.momentOfInertiaDrivenRoll}
              unitVal={mechanics.momentOfInertiaDrivenRollUnit}
              handleInputChange={handleInputChange}
              label="Moment of inertia of the driven roll"
              labelRequired={true}
              options={["kg.cm²", "kg.m²", "oz.in²", "lb.in²", "lb.ft²"]}
              subLabel={hideDetails ? subLabeltext : ""}
              inputClasses="rounded-md"
            />
            <AddOption
              name="additionalMomentOfInertia"
              value={mechanics.additionalMomentOfInertia}
              unitVal={mechanics.additionalMomentOfInertiaUnit}
              handleInputChange={handleInputChange}
              label="additional Moment Of Inertia"
              options={["kg.cm²", "kg.m²", "oz.in²", "lb.in²", "lb.ft²"]}
              subLabel={hideDetails ? subLabeltext : ""}
              inputClasses="rounded-md"
            />
            <AddOption
              name="kineticFrictionForce"
              value={mechanics.kineticFrictionForce}
              unitVal={mechanics.kineticFrictionForceUnit}
              handleInputChange={handleInputChange}
              label="Kinetic friction force"
              options={["N.m", "lb.ft"]}
              subLabel={hideDetails ? subLabeltext : ""}
              inputClasses="rounded-md"
            />
            <AddOption
              name="materialTensionForce"
              value={mechanics.materialTensionForce}
              unitVal={mechanics.materialTensionForceUnit}
              handleInputChange={handleInputChange}
              label="Material tension force"
              options={["N.m", "lb.ft"]}
              subLabel={hideDetails ? subLabeltext : ""}
              inputClasses="rounded-md"
            />
            <AddOption
              name="additionalConstantForce"
              value={mechanics.additionalConstantForce}
              unitVal={mechanics.additionalConstantForceUnit}
              handleInputChange={handleInputChange}
              label="Additional constant force"
              options={["N.m", "lb.ft"]}
              subLabel={hideDetails ? subLabeltext : ""}
              inputClasses="rounded-md"
            />
            <AddOption
              name="viscousFrictionforce"
              value={mechanics.viscousFrictionforce}
              unitVal={mechanics.viscousFrictionforceUnit}
              handleInputChange={handleInputChange}
              label="Viscous friction force"
              options={["N.m", "lb.ft"]}
              subLabel={hideDetails ? subLabeltext : ""}
              inputClasses="rounded-md"
            />
            <div className="mb-3" />
          </div>
        )}
        {mechanics.isMechanics === "Conveyor belt" && (
          <div className="ml-3 thin-scrollbar overflow-visible h-full">
            <AddOption
              name="diameterDriveRoll"
              value={mechanics.diameterDriveRoll}
              unitVal={mechanics.diameterDriveRollUnit}
              handleInputChange={handleInputChange}
              label="diameterof the drive roll"
              options={["m", "mm", "cm", "in", "ft"]}
              labelRequired={true}
              inputClasses="step-4 rounded-md"
              subLabel={hideDetails ? subLabeltext : ""}
            />
            <AddOption
              name="massLoad"
              value={mechanics.massLoad}
              unitVal={mechanics.massLoadUnit}
              handleInputChange={handleInputChange}
              label="Mass of the load"
              options={["kg", "g", "lb", "oz."]}
              labelRequired={true}
              subLabel={hideDetails ? subLabeltext : ""}
              inputClasses="rounded-md"
            />
            <AddOption
              name="massBelt"
              value={mechanics.massBelt}
              unitVal={mechanics.massBeltUnit}
              handleInputChange={handleInputChange}
              label="Mass of the belt"
              options={["kg", "g", "lb", "oz."]}
              labelRequired={true}
              subLabel={hideDetails ? subLabeltext : ""}
              inputClasses="rounded-md"
            />
            <AddOption
              name="momentOfInertiaDriveRoll"
              value={mechanics.momentOfInertiaDriveRoll}
              unitVal={mechanics.momentOfInertiaDriveRollUnit}
              handleInputChange={handleInputChange}
              label="Moment of inertia of the drive roll"
              labelRequired={true}
              options={["kg.cm²", "kg.m²", "oz.in²", "lb.in²", "lb.ft²"]}
              subLabel={hideDetails ? subLabeltext : ""}
              inputClasses="rounded-md"
            />
            <AddOption
              name="momentOfInertiaDrivenRoll"
              value={mechanics.momentOfInertiaDrivenRoll}
              unitVal={mechanics.momentOfInertiaDrivenRollUnit}
              handleInputChange={handleInputChange}
              label="Moment of inertia of the driven roll"
              labelRequired={true}
              options={["kg.cm²", "kg.m²", "oz.in²", "lb.in²", "lb.ft²"]}
              subLabel={hideDetails ? subLabeltext : ""}
              inputClasses="rounded-md"
            />
            <AddOption
              name="momentOfInertiaAdditionalRoll"
              value={mechanics.momentOfInertiaAdditionalRoll}
              unitVal={mechanics.momentOfInertiaAdditionalRollUnit}
              handleInputChange={handleInputChange}
              label="Moment of inertia of additional rolls "
              options={["kg.cm²", "kg.m²", "oz.in²", "lb.in²", "lb.ft²"]}
              subLabel={hideDetails ? subLabeltext : ""}
              inputClasses="rounded-md"
            />
            <AddOption
              name="kineticFrictionForce"
              value={mechanics.kineticFrictionForce}
              unitVal={mechanics.kineticFrictionForceUnit}
              handleInputChange={handleInputChange}
              label="Kinetic friction force"
              options={["N.m", "lb.ft"]}
              subLabel={hideDetails ? subLabeltext : ""}
              inputClasses="rounded-md"
            />
            <AddOption
              name="additionalConstantForce"
              value={mechanics.additionalConstantForce}
              unitVal={mechanics.additionalConstantForceUnit}
              handleInputChange={handleInputChange}
              label="Additional constant force"
              options={["N.m", "lb.ft"]}
              subLabel={hideDetails ? subLabeltext : ""}
              inputClasses="rounded-md"
            />
            <AddOption
              name="viscousFrictionforce"
              value={mechanics.viscousFrictionforce}
              unitVal={mechanics.viscousFrictionforceUnit}
              handleInputChange={handleInputChange}
              label="Viscous friction force"
              options={["N.m", "lb.ft"]}
              subLabel={hideDetails ? subLabeltext : ""}
              inputClasses="rounded-md"
            />
            <AddOption
              name="inclinationAngle"
              value={mechanics.inclinationAngle}
              unitVal={mechanics.inclinationAngleUnit}
              handleInputChange={handleInputChange}
              label="Inclination angle"
              options={["°", "rad"]}
              subLabel={hideDetails ? subLabeltext : ""}
              inputClasses="rounded-md"
            />
            <div className="mb-3" />
          </div>
        )}
        {mechanics.isMechanics === "Spindle drive" && (
          <div className="ml-3 thin-scrollbar overflow-visible h-full">
            <AddOption
              name="threadPitch"
              value={mechanics.threadPitch}
              unitVal={mechanics.threadPitchUnit}
              handleInputChange={handleInputChange}
              label="Thread Pitch"
              options={["m", "mm", "cm", "in", "ft"]}
              labelRequired={true}
              inputClasses="step-4 rounded-md"
              subLabel={hideDetails ? subLabeltext : ""}
            />
            <AddOption
              name="efficiency"
              value={mechanics.efficiency}
              unitVal={mechanics.efficiencyUnit}
              handleInputChange={handleInputChange}
              label="Efficiency"
              options={["%", "η"]}
              labelRequired={true}
              subLabel={hideDetails ? subLabeltext : ""}
              inputClasses="rounded-md"
            />
            <AddOption
              name="additionalMomentOfInertia"
              value={mechanics.additionalMomentOfInertia}
              unitVal={mechanics.additionalMomentOfInertiaUnit}
              handleInputChange={handleInputChange}
              label="additional Moment Of Inertia"
              options={["kg.cm²", "kg.m²", "oz.in²", "lb.in²", "lb.ft²"]}
              subLabel={hideDetails ? subLabeltext : ""}
              inputClasses="rounded-md"
            />
            <AddOption
              name="kineticFrictionForce"
              value={mechanics.kineticFrictionForce}
              unitVal={mechanics.kineticFrictionForceUnit}
              handleInputChange={handleInputChange}
              label="Kinetic friction force"
              options={["N.m", "lb.ft"]}
              subLabel={hideDetails ? subLabeltext : ""}
              inputClasses="rounded-md"
            />
            <AddOption
              name="additionalConstantForce"
              value={mechanics.additionalConstantForce}
              unitVal={mechanics.additionalConstantForceUnit}
              handleInputChange={handleInputChange}
              label="Additional constant force"
              options={["N.m", "lb.ft"]}
              subLabel={hideDetails ? subLabeltext : ""}
              inputClasses="rounded-md"
            />
            <AddOption
              name="viscousFrictionforce"
              value={mechanics.viscousFrictionforce}
              unitVal={mechanics.viscousFrictionforceUnit}
              handleInputChange={handleInputChange}
              label="Viscous friction force"
              options={["N.m", "lb.ft"]}
              subLabel={hideDetails ? subLabeltext : ""}
              inputClasses="rounded-md"
            />
            <AddOption
              name="inclinationAngle"
              value={mechanics.inclinationAngle}
              unitVal={mechanics.inclinationAngleUnit}
              handleInputChange={handleInputChange}
              label="Inclination angle"
              options={["°", "rad"]}
              subLabel={hideDetails ? subLabeltext : ""}
              inputClasses="rounded-md"
            />
            <div className="mb-3" />
          </div>
        )}
        {mechanics.isMechanics === "Rack and pinion gear" && (
          <div className="ml-3 thin-scrollbar overflow-visible h-full">
            <div className="text-sm font-bold">Pinion</div>
            <AddOptionRadio
              name="pinion"
              handleInputChange={handleInputChange}
              label=""
              inputClasses="step-4 rounded-md"
              subLabel={hideDetails ? subLabeltext : ""}
              mechanics={mechanics}
            />
            <AddOption
              name="toothPitch"
              value={mechanics.toothPitch}
              unitVal={mechanics.toothPitchUnit}
              handleInputChange={handleInputChange}
              label="Tooth pitch"
              options={["m", "mm", "cm", "in", "ft"]}
              labelRequired={true}
              inputClasses="step-4 rounded-md"
              subLabel={hideDetails ? subLabeltext : ""}
            />
            <AddOption
              name="numberOfTeeth"
              value={mechanics.numberOfTeeth}
              unitVal={mechanics.numberOfTeethUnit}
              handleInputChange={handleInputChange}
              label="Number of teeth"
              options={[]}
              labelRequired={true}
              subLabel={hideDetails ? subLabeltext : ""}
              inputClasses="rounded-md"
            />
            <div className="text-sm font-bold">Rack and pinion</div>
            {/* <CalculatorSection /> */}
            <AddOption
              name="massLoad"
              value={mechanics.massLoad}
              unitVal={mechanics.massLoadUnit}
              handleInputChange={handleInputChange}
              label="Mass of the load"
              labelRequired={true}
              options={["kg", "g", "lb", "oz."]}
              subLabel={hideDetails ? subLabeltext : ""}
              inputClasses="rounded-md"
            />
            <AddOption
              name="massRack"
              value={mechanics.massRack}
              unitVal={mechanics.massRackUnit}
              handleInputChange={handleInputChange}
              label="Mass of the rack"
              labelRequired={true}
              options={["kg", "g", "lb", "oz."]}
              subLabel={hideDetails ? subLabeltext : ""}
              inputClasses="rounded-md"
            />
            <AddOption
              name="additionalMomentOfInertia"
              value={mechanics.additionalMomentOfInertia}
              unitVal={mechanics.additionalMomentOfInertiaUnit}
              handleInputChange={handleInputChange}
              label="additional Moment Of Inertia"
              options={["kg.cm²", "kg.m²", "oz.in²", "lb.in²", "lb.ft²"]}
              subLabel={hideDetails ? subLabeltext : ""}
              inputClasses="rounded-md"
            />
            <AddOption
              name="kineticFrictionForce"
              value={mechanics.kineticFrictionForce}
              unitVal={mechanics.kineticFrictionForceUnit}
              handleInputChange={handleInputChange}
              label="Kinetic friction force"
              options={["N.m", "lb.ft"]}
              subLabel={hideDetails ? subLabeltext : ""}
              inputClasses="rounded-md"
            />
            <AddOption
              name="additionalConstantForce"
              value={mechanics.additionalConstantForce}
              unitVal={mechanics.additionalConstantForceUnit}
              handleInputChange={handleInputChange}
              label="Additional constant force"
              options={["N.m", "lb.ft"]}
              subLabel={hideDetails ? subLabeltext : ""}
              inputClasses="rounded-md"
            />
            <AddOption
              name="viscousFrictionforce"
              value={mechanics.viscousFrictionforce}
              unitVal={mechanics.viscousFrictionforceUnit}
              handleInputChange={handleInputChange}
              label="Viscous friction force"
              options={["N.m", "lb.ft"]}
              subLabel={hideDetails ? subLabeltext : ""}
              inputClasses="rounded-md"
            />
            <AddOption
              name="inclinationAngle"
              value={mechanics.inclinationAngle}
              unitVal={mechanics.inclinationAngleUnit}
              handleInputChange={handleInputChange}
              label="Inclination angle"
              options={["°", "rad"]}
              subLabel={hideDetails ? subLabeltext : ""}
              inputClasses="rounded-md"
            />
            <div className="mb-3" />
          </div>
        )}
        {mechanics.isMechanics === "Crank" && (
          <div className="ml-3 thin-scrollbar overflow-visible h-full">
            <AddOption
              name="crankArmLength"
              value={mechanics.crankArmLength}
              unitVal={mechanics.crankArmLengthUnit}
              handleInputChange={handleInputChange}
              label="Crank arm length"
              options={["m", "mm", "cm", "in", "ft"]}
              labelRequired={true}
              inputClasses="step-4 rounded-md"
              subLabel={hideDetails ? subLabeltext : ""}
            />
            <AddOption
              name="pushRodLength"
              value={mechanics.pushRodLength}
              unitVal={mechanics.pushRodLengthUnit}
              handleInputChange={handleInputChange}
              label="Crank arm length"
              options={["m", "mm", "cm", "in", "ft"]}
              labelRequired={true}
              inputClasses="step-4 rounded-md"
              subLabel={hideDetails ? subLabeltext : ""}
            />
            <AddOption
              name="xStart"
              value={mechanics.xStart}
              unitVal={mechanics.xStartUnit}
              handleInputChange={handleInputChange}
              label="X start"
              options={["m", "mm", "cm", "in", "ft"]}
              labelRequired={true}
              inputClasses="step-4 rounded-md"
              subLabel={hideDetails ? subLabeltext : ""}
            />
            <AddOption
              name="offsetFromSlideLevelToCrankShaft"
              value={mechanics.offsetFromSlideLevelToCrankShaft}
              unitVal={mechanics.offsetFromSlideLevelToCrankShaftUnit}
              handleInputChange={handleInputChange}
              label="Offset from slide level to crank shaft"
              options={["m", "mm", "cm", "in", "ft"]}
              labelRequired={true}
              inputClasses="step-4 rounded-md"
              subLabel={hideDetails ? subLabeltext : ""}
            />
            <AddOption
              name="minimalPositionOfTheSlide"
              value={mechanics.minimalPositionOfTheSlide}
              unitVal={mechanics.minimalPositionOfTheSlideUnit}
              handleInputChange={handleInputChange}
              label="Minimal position of the slide"
              options={["m", "mm", "cm", "in", "ft"]}
              labelRequired={true}
              inputClasses="step-4 rounded-md"
              subLabel={hideDetails ? subLabeltext : ""}
            />
            <AddOption
              name="maximalPositionOfTheSlide"
              value={mechanics.maximalPositionOfTheSlide}
              unitVal={mechanics.maximalPositionOfTheSlideUnit}
              handleInputChange={handleInputChange}
              label="Maximal position of the slide"
              options={["m", "mm", "cm", "in", "ft"]}
              labelRequired={true}
              inputClasses="step-4 rounded-md"
              subLabel={hideDetails ? subLabeltext : ""}
            />
            <AddOption
              name="massLoad"
              value={mechanics.massLoad}
              unitVal={mechanics.massLoadUnit}
              handleInputChange={handleInputChange}
              label="Mass of the load"
              options={["kg", "g", "lb", "oz."]}
              labelRequired={true}
              subLabel={hideDetails ? subLabeltext : ""}
              inputClasses="rounded-md"
            />
            <AddOption
              name="additionalMomentOfInertia"
              value={mechanics.additionalMomentOfInertia}
              unitVal={mechanics.additionalMomentOfInertiaUnit}
              handleInputChange={handleInputChange}
              label="additional Moment Of Inertia"
              options={["kg.cm²", "kg.m²", "oz.in²", "lb.in²", "lb.ft²"]}
              subLabel={hideDetails ? subLabeltext : ""}
              inputClasses="rounded-md"
            />
            <AddOption
              name="kineticFrictionForce"
              value={mechanics.kineticFrictionForce}
              unitVal={mechanics.kineticFrictionForceUnit}
              handleInputChange={handleInputChange}
              label="Kinetic friction force"
              options={["N.m", "lb.ft"]}
              subLabel={hideDetails ? subLabeltext : ""}
              inputClasses="rounded-md"
            />
            <AddOption
              name="additionalConstantForce"
              value={mechanics.additionalConstantForce}
              unitVal={mechanics.additionalConstantForceUnit}
              handleInputChange={handleInputChange}
              label="Additional constant force"
              options={["N.m", "lb.ft"]}
              subLabel={hideDetails ? subLabeltext : ""}
              inputClasses="rounded-md"
            />
            <AddOption
              name="viscousFrictionforce"
              value={mechanics.viscousFrictionforce}
              unitVal={mechanics.viscousFrictionforceUnit}
              handleInputChange={handleInputChange}
              label="Viscous friction force"
              options={["N.m", "lb.ft"]}
              subLabel={hideDetails ? subLabeltext : ""}
              inputClasses="rounded-md"
            />
            <div className="mb-3" />
          </div>
        )}
        <div class="flex p-2 justify-center absolute bottom-0 bg-white border-t right-[18px] w-[30%] z-10">
          <ApplySection enable={mechanics.isValid} handleContinue={handleContinue} />
        </div>
      </div>
    </div>
  );
};

const HelpMeToUseSection = ({ isTourEnabled, setIsTourEnabled }) => {
  return (
    <div className="flex ml-2">
      <span className="transform scale-75">
        <ToggleInput
          onChange={(e) => {
            const section = document.querySelector(`.step-3`);
            section?.scrollIntoView({ behavior: "instant", block: "start" });
            setTimeout(() => {
              setIsTourEnabled(e);
            }, 1);
          }}
          checked={isTourEnabled}
          switchable
        />
      </span>
      <span className="text-[12px] mt-[2px]">Help me to use</span>
    </div>
  );
};

const SizingDefineMechanics = () => {
  const mechanics = useSelector(selectSizingMechanics);
  const dispatch = useDispatch();
  const [isTourEnabled, setIsTourEnabled] = useState(false);

  useEffect(() => {
    // set localStorage to display the guided tour for the new users
    if (localStorage.getItem("msizerGuidedTour") === null) {
      localStorage.setItem("msizerGuidedTour", true);
      setTimeout(() => {
        setIsTourEnabled(true);
      }, 1000);
    }
  }, []);

  /*
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    // const isValid = name === FEED_CONSTANT && value !== "" ? true : false;
    const newData = {
      ...mechanics,
      [name]: value
      // isValid: isValid
    };
    dispatch(setSizingMechanics(newData));
  };*/

  const handleInputChange = (e) => {
    const { name } = e.target;
    let { value } = e.target;

    const resolvedName = MechanicsOptionsLabels.includes(name) ? "isMechanics" : name;

    // Initialize/reset fields for unselected steps
    const resetFields = {};
    if (MechanicsOptionsLabels.includes(name)) {
      MechanicsOptionsLabels.forEach((step) => {
        if (step !== name) {
          (mandatoryFields[step] || []).forEach((field) => {
            resetFields[field] = ""; // Reset unselected step fields to empty
          });
        }
      });
    }

    const newData = {
      ...mechanics,
      ...resetFields, // Apply reset fields
      //pinion: value,
      [resolvedName]: MechanicsOptionsLabels.includes(name) ? name : value
    };

    // Update the mechanics state
    dispatch(setSizingMechanics(newData));

    // Validate mandatory fields for the current step
    const currentStep = MechanicsOptionsLabels.includes(name) ? name : mechanics.isMechanics;
    const requiredFields = mandatoryFields[currentStep] || [];
    const isValid = requiredFields.every((field) => newData[field] && newData[field].trim() !== "");

    // Update the isValid state
    dispatch(
      setSizingMechanics({
        ...newData,
        isValid
      })
    );
  };

  const handleContinue = () => {
    dispatch(setCurrentSizingStep(STEPS.RETROFIT_SIZING.DEFINE_DYNAMICS));
    dispatch(updateConfiguration());
  };

  return (
    <div>
      {isTourEnabled && <GuidedTour steps={GUIDED_STEPS} setIsTourEnabled={setIsTourEnabled} />}
      <div className="flex">
        <LeftSection
          isTourEnabled={isTourEnabled}
          setIsTourEnabled={setIsTourEnabled}
          handleInputChange={handleInputChange}
          mechanics={mechanics}
        />
        <RightSection handleInputChange={handleInputChange} mechanics={mechanics} handleContinue={handleContinue} />
      </div>
    </div>
  );
};

export default SizingDefineMechanics;
